import React from 'react'

import Header from '../../components/Header/index'
import Footer from '../../components/Footer/index'
import { TerminosCondicionesText } from '../../components/InstitutionalText/index'
import MenuAside from '../../components/MenuAside/index'

const TerminosCondiciones = () => {
  return (
    <>
      <Header page="blog" />
      <TerminosCondicionesText />
      <Footer />
      <MenuAside />
    </>
  );
};

export default TerminosCondiciones
